var AccessibilityCommandId;
( (function(AccessibilityCommandId) {
    AccessibilityCommandId["OpenAccessibleView"] = "editor.action.accessibleView";
    AccessibilityCommandId["OpenAccessibilityHelp"] = "editor.action.accessibilityHelp";
    AccessibilityCommandId["DisableVerbosityHint"] = "editor.action.accessibleViewDisableHint";
    AccessibilityCommandId["GoToSymbol"] = "editor.action.accessibleViewGoToSymbol";
    AccessibilityCommandId["ShowNext"] = "editor.action.accessibleViewNext";
    AccessibilityCommandId["ShowPrevious"] = "editor.action.accessibleViewPrevious";
    AccessibilityCommandId["AccessibleViewAcceptInlineCompletion"] = "editor.action.accessibleViewAcceptInlineCompletion";
    AccessibilityCommandId["NextCodeBlock"] = "editor.action.accessibleViewNextCodeBlock";
    AccessibilityCommandId["PreviousCodeBlock"] = "editor.action.accessibleViewPreviousCodeBlock";
    AccessibilityCommandId["AccessibilityHelpConfigureKeybindings"] = "editor.action.accessibilityHelpConfigureKeybindings";
    AccessibilityCommandId["AccessibilityHelpOpenHelpLink"] = "editor.action.accessibilityHelpOpenHelpLink";
})(AccessibilityCommandId || (AccessibilityCommandId = {})));
export { AccessibilityCommandId };
